import { Checkbox } from "./checkbox";
export * from "./checkbox";
export var CHECKBOX_DIRECTIVES = [
    Checkbox
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/forms/checkbox/index.js
// module id = 184
// module chunks = 4